import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { DashboardComponent } from "./dashboard/dashboard.component";
import { SignInFormComponent } from "./sign-in-form/sign-in-form.component";
import { SignUpFormComponent } from "./sign-up-form/sign-up-form.component";

//TEM QUE IMPORTAR O COMPONENTE PARA PODER USA-LO
import { TasksComponent } from './tasks/tasks.component';
import { TaskDetailComponent } from './tasks/task-detail/task-detail.component';

//CRIA UMA CONSTANTE PARA AS ROTAS DO SISTEMAS
const ROUTES = RouterModule.forRoot([
    {
      path: 'sign-in',
      component: SignInFormComponent
    },

    {
      path: 'sign-up',
      component: SignUpFormComponent
    },
  
    {
      path: 'tasks/:id',
      component: TaskDetailComponent
    },
  
    {
      path: 'dashboard',
      component: DashboardComponent
    },
  
    {
      path: 'tasks',
      component: TasksComponent
    },

    {
      path: 'http://www.agenciasnet.com.br/tasks',
      component: TasksComponent,
    },
  
    {//REDIRECIONAMENTO DO ANGULAR COM ROTAS
      path: '',
      redirectTo: '/dashboard',
      pathMatch: 'full'
    }
  ])

  @NgModule({
      //declarations: [],
      imports: [ ROUTES ],
      exports: [ RouterModule ], //EXPORTA O ROUTERMODULE PARA QUE TODOS QUE IMPORTAR ESTE ARQUIVO TER ACESSO A ROUTERMODULE
      //providers: [],
  })

  export class AppRoutingModule {}


// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/app-routing.module.ts